import { trace } from './trace'

const DONT_MLOG = true

// 各业务线岳鹰的msg附加上版本前缀;(bizPrefix可以是数组,如果是数组,会用-连起来作为后缀)
function getMsgAppendGroup(msg, bizPrefix) {
  let msgUpload = msg || ''
  let zt_verName =
    (window.zzzconfig && window.zzzconfig.getZatuVerName && window.zzzconfig.getZatuVerName()) || 'zaitu-ver'

  const ztVer = (window.$tool && window.$tool.getCookie(zt_verName)) || ''
  if (typeof bizPrefix !== 'undefined' && ztVer != '') {
    if (Object.prototype.toString.call(bizPrefix) === '[object Array]') {
      bizPrefix.forEach((element) => {
        msgUpload = msgUpload + '_' + matchString(ztVer, element)
      })
    } else if (Object.prototype.toString.call(bizPrefix) === '[object String]') {
      msgUpload = msgUpload + '_' + matchString(ztVer, bizPrefix)
    }
  }
  return msgUpload
}
function matchString(ztVerStr, searchString) {
  const groups = ztVerStr.split('-')
  const regex = new RegExp(`^${searchString}\\d+.*$`)
  for (const group of groups) {
    if (group.match(regex)) {
      return group
    }
  }
  return ''
}

function appendExtInfo(params) {
  let localUserInfo = localStorage.getItem('localUserInfo') || '{}'
  localUserInfo = JSON.parse(localUserInfo)
  let zt_verName =
    (window.zzzconfig && window.zzzconfig.getZatuVerName && window.zzzconfig.getZatuVerName()) || 'zaitu-ver'

  return Object.assign({}, params, {
    'zaitu-ver': (window.$tool && window.$tool.getCookie(zt_verName)) || '',
    userId: localUserInfo.userId,
    userMobile: localUserInfo.mobile,
    location: location.href,
    ua: navigator.userAgent.toLowerCase()
  })
}

class mconsole {
  constructor() {
    if (DONT_MLOG) {
      console.log('closed mconcole....')
      return
    }
    this.config = {}

    this.startUploadByPage = this.startUploadByPage.bind(this)
    this.endUploadByPage = this.endUploadByPage.bind(this)
  }

  // 上传短数据字符串时用的是c1
  upYueYing(msg, params, code, w_succ = 0, bizPrefix) {
    try {
      let msgUpload = getMsgAppendGroup(msg, bizPrefix)
      window.__wpk &&
        window.__wpk.report({
          category: code,
          msg: msgUpload,
          w_succ: w_succ,
          c1: typeof params === 'object' ? JSON.stringify(appendExtInfo(params)) : params // 可选， 辅助字段，可在日志详情中看到，共有c1~c5 5 个
        })
    } catch (e) {
      trace.log('yueyin-error', {
        type: 'upYueYing',
        error: e
      })
    }
  }

  // 平均时间
  upYueYingAvg(msg, avg, code, bizPrefix) {
    try {
      let msgUpload = getMsgAppendGroup(msg, bizPrefix)
      window.__wpk &&
        window.__wpk.report({
          category: code,
          msg: msgUpload,
          wl_avgv1: avg,
          c1: sessionStorage.getItem('WEB_SESSION_ID')
        })
    } catch (e) {
      trace.log('yueyin-error', {
        type: 'upYueYingAvg',
        error: e
      })
    }
  }
  // 上传大数据字符串字段时用的是bl1
  upYueYing2(msg, params, code, w_succ = 0, bizPrefix) {
    try {
      let msgUpload = getMsgAppendGroup(msg, bizPrefix)
      window.__wpk &&
        window.__wpk.report({
          category: code,
          msg: msgUpload,
          w_succ: w_succ,
          bl1: typeof params === 'object' ? JSON.stringify(appendExtInfo(params)) : params // 可选， 辅助字段，可在日志详情中看到，共有c1~c5 5 个
        })
      trace.log('yueyin', {
        category: code,
        msg: msgUpload,
        w_succ: w_succ,
        bl1: typeof params === 'object' ? JSON.stringify(appendExtInfo(params)) : params // 可选， 辅助字段，可在日志详情中看到，共有c1~c5 5 个
      })
    } catch (e) {
      trace.log('yueyin-error', {
        type: 'upYueYing2',
        error: e
      })
    }
  }
  startUploadByPage(page_key) {
    localStorage.setItem(page_key, new Date().getTime())
  }
  /**
   *
   * @param {*} page_key 存储到localstorage的唯一key { w_succ: 1, category: 101, msg: '页面耗时', bl1: '', c1: '' }  c1只支持200个字符左右的小字符串, bl1:支持比较长的字符串
   * @param {*} config  { w_succ:是否成功(可以理解为接口是否成功) 0成功,1失败 ,category: 岳鹰监控分配的分类id,msg: 监控描述,如果首页加载耗时  }
   * maxTimeLimit 最大时长,多余这个时长会被丢弃;当成无效数据
   *
   * @returns
   */
  endUploadByPage(
    page_key,
    config = {},
    matchUrl,
    maxTimeLimit = 20000,
    bizPrefix // 各业务线前缀如 pp71p1-op37-de2-mo4-bi29-it36-ht32p2-bp62-ft55-et23p1-oa38p1-ex32-ca42-tr40 如 公共组pp,
  ) {
    const now = Date.now()
    setTimeout(() => {
      let lTime = localStorage.getItem(page_key)
      if (!lTime) return
      if (matchUrl && location.href.indexOf(matchUrl) === -1) {
        console.log(page_key, '不匹配当前路由,抛弃', matchUrl, location.href)
        return
      }
      const lastTime = now - parseInt(lTime)
      if (typeof maxTimeLimit !== 'number') {
        // 有的乱传参,导致maxTimeLimit错误
        maxTimeLimit = 10000
      }
      if (lastTime > maxTimeLimit) {
        // 脏数据,抛弃
        console.log('脏数据,抛弃', config.msg, lastTime)
        localStorage.removeItem(page_key)
        return
      }
      const msgUpload = getMsgAppendGroup(config.msg, bizPrefix)
      console.log('msgUpload', msgUpload, lastTime)
      const reportConfig = {
        category: config.category,
        msg: msgUpload,
        w_succ: config.w_succ,
        wl_avgv1: lastTime // 耗时100ms
      }
      trace.tag('endUploadByPage', {
        data: reportConfig
      })
      // 如果传了 bl1 ,则支持大字符串
      if (config.bl1 != '') {
        reportConfig.bl1 = config.bl1
      }
      if (config.c1 != '') {
        reportConfig.c1 = config.c1
      }
      window.__wpk && window.__wpk.report(reportConfig)
      // console.log(page_key + "上传成功", JSON.stringify(reportConfig))
      localStorage.removeItem(page_key)
    }, 2000)
  }
}
// 使用单利模式
let _instance = null
function getMLogInstance({ appProject }) {
  console.log('getMLogInstance')
  if (_instance) {
    return _instance
  }
  _instance = new mconsole({ appProject })
  window.mconsole = _instance
  return _instance
}
export default getMLogInstance
